import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import { Navigate } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Form, Button, Radio, Input, Message } from "semantic-ui-react";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import { saveAs } from "file-saver";
import "./ConstanciasAlumnos.css";

function ConstanciasAlumnos() {
  const { auth } = useAuth();
  if (!auth?.me?.es_personal_control_escolar) {
    return <Navigate to={"/"} />;
  }
  return <LogicaConstanciasAlumnos />;
}

function LogicaConstanciasAlumnos() {
  const { auth } = useAuth();
  const [searchType, setSearchType] = useState("matricula");
  const [searchValue, setSearchValue] = useState("");
  const [alumno, setAlumno] = useState(null);
  const [cicloEscolar, setCicloEscolar] = useState(null);
  const [grupo, setGrupo] = useState(null);
  const [error, setError] = useState(null);
  const [cicloAnio, setCicloAnio] = useState(null);
  const [fechaActual, setfechaActual] = useState(null);
  const [estadoAlumno, setEstadoAlumno] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (alumno) {
        await fetchGrupoYCicloEscolar(alumno);
        await determinarEstadoAlumno(alumno);
      }
    };

    fetchData();
  }, [alumno]);

  const handleSearchSubmit = async (event) => {
    event.preventDefault();
    if (!searchValue.trim()) {
      setError("Por favor, ingrese un valor antes de buscar.");
      return;
    }

    setError(false);

    try {
      const searchParam = searchType === "matricula" ? "matricula" : "curp";
      const response = await axios.get(
        `${BASE_API}/api/alumno/?${searchParam}=${searchValue}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const result = response.data;
      if (result && result.length > 0) {
        const alumnito = result[0];
        setAlumno(alumnito);
        await fetchGrupoYCicloEscolar(alumnito);
        await determinarEstadoAlumno(alumnito);
      } else {
        setError("No se encontraron resultados");
      }
    } catch (error) {
      console.error("Error fetching alumno data", error);
    }
  };

  const fetchGrupoYCicloEscolar = async (alumno) => {
    try {
      const [grupo, cicloEscolar] = await Promise.all([
        getGrupoActualDelAlumno(alumno),
        getCicloEscolar(),
        obtenerFechaActualTexto(),
      ]);
      setGrupo(grupo);
      setCicloEscolar(cicloEscolar);
    } catch (error) {
      console.error("Error fetching grupo y ciclo escolar", error);
    }
  };

  async function getCicloEscolar() {
    try {
      const response = await axios.get(`${BASE_API}/api/ciclo_escolar/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      const ciclosEscolares = response.data;
      if (ciclosEscolares.length === 0) {
        throw new Error("No hay ciclos escolares disponibles");
      }

      const fechaActual = new Date();
      const cicloActual = ciclosEscolares.reduce((cicloMasActual, ciclo) => {
        const fechaInicio = new Date(ciclo.fecha_inicio);
        const fechaFin = new Date(ciclo.fecha_fin);

        const incluyeFechaActual =
          fechaInicio <= fechaActual && fechaActual <= fechaFin;

        if (incluyeFechaActual) {
          return ciclo;
        }

        if (
          !cicloMasActual ||
          fechaInicio > new Date(cicloMasActual.fecha_inicio)
        ) {
          return ciclo;
        }

        return cicloMasActual;
      }, null);

      let cicloAnios = null;
      if (cicloActual) {
        cicloActual.fecha_inicio = formatearFecha(cicloActual.fecha_inicio);
        cicloActual.fecha_fin = formatearFecha(cicloActual.fecha_fin);

        const anioInicio = obtenerAnio(cicloActual.fecha_inicio);
        const anioFin = obtenerAnio(cicloActual.fecha_fin);
        cicloAnios = { anioInicio, anioFin };
        setCicloAnio(cicloAnios);
      }

      return cicloActual;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  function obtenerAnio(fechaString) {
    const partes = fechaString.split(" ");
    const anioString = partes[partes.length - 1];
    const anio = parseInt(anioString, 10);
    return anio;
  }

  function formatearFecha(fechaISO) {
    const fecha = new Date(fechaISO);
    const opciones = { day: "numeric", month: "long", year: "numeric" };
    return fecha.toLocaleDateString("es-ES", opciones);
  }

  async function getGrupoActualDelAlumno(alumno) {
    try {
      const response = await axios.get(`${BASE_API}/api/grupo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const grupos = response.data;

      const grupoActual = grupos.find((grupo) =>
        grupo.alumnos.includes(alumno.id)
      );

      if (grupoActual === undefined) {
        setError(
          "El alumno no se encuentra en ningun grupo, verifique los datos"
        );
      } else {
        return grupoActual;
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  function obtenerFechaActualTexto() {
    const fechaActual = new Date();
    const diasSemana = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ];
    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];

    const dia = diasSemana[fechaActual.getDay()];
    const diaNumero = fechaActual.getDate();
    const mes = meses[fechaActual.getMonth()];
    const anio = fechaActual.getFullYear();
    const anioTexto = obtenerAnioTexto(anio);

    const fecha = {
      dia: dia,
      diaNumero: diaNumero,
      mes: mes,
      anio: anio,
      anioTexto: anioTexto,
    };
    setfechaActual(fecha);
    return fecha;
  }

  function obtenerAnioTexto(anio) {
    const unidades = [
      "",
      "uno",
      "dos",
      "tres",
      "cuatro",
      "cinco",
      "seis",
      "siete",
      "ocho",
      "nueve",
    ];
    const especiales = ["diez", "once", "doce", "trece", "catorce", "quince"];
    const decenas = ["", "", "veinti", "treinta"];
    const centenas = ["", "ciento", "dos", "tres"];

    const anioTexto = [];

    if (anio >= 1000 && anio <= 9999) {
      const miles = Math.floor(anio / 1000);
      if (miles > 0) {
        anioTexto.push(centenas[miles]);
        anioTexto.push("mil");
      }

      anio %= 1000;
    }

    if (anio >= 100) {
      const cent = Math.floor(anio / 100);
      if (cent > 1) {
        anioTexto.push(centenas[cent]);
      } else {
        anioTexto.push("cien");
      }

      anio %= 100;
    }

    if (anio >= 10 && anio <= 15) {
      anioTexto.push(especiales[anio - 10]);
    } else {
      const dec = Math.floor(anio / 10);
      if (dec > 0) {
        anioTexto.push(decenas[dec]);
      }

      const uni = anio % 10;
      if (uni > 0) {
        anioTexto.push(unidades[uni]);
      }
    }

    return anioTexto.join(" ");
  }

  const determinarEstadoAlumno = async () => {
    try {
      const response = await axios.get(
        `${BASE_API}/api/calificacion_curso/?alumno=${alumno.id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const calificaciones = response.data;

      let esRegular = false;

      for (const calificacion of calificaciones) {
        const calificacionFinal = parseFloat(calificacion.calificacion_final);
        const regularizacion1 = parseFloat(calificacion.regularizacion_1);
        const regularizacion2 = parseFloat(calificacion.regularizacion_2);

        if (calificacionFinal >= 6.0) {
          esRegular = true;
        } else if (calificacionFinal === 5.0) {
          // Revisar si alguna de las recuperaciones es mayor o igual a 6
          if (
            (regularizacion1 && regularizacion1 >= 6.0) ||
            (regularizacion2 && regularizacion2 >= 6.0)
          ) {
            esRegular = true;
          } else {
            setEstadoAlumno("IRREGULAR");
            return;
          }
        }
      }

      setEstadoAlumno(esRegular ? "REGULAR" : "IRREGULAR");
    } catch (error) {
      console.error("Error fetching calificaciones", error);
    }
  };

  const generateDocument = async () => {
    if (
      !alumno ||
      !grupo ||
      !cicloEscolar ||
      !cicloAnio ||
      !fechaActual ||
      !estadoAlumno
    ) {
      setError("Faltan datos para generar el documento");
      return;
    }

    try {
      const templateResponse = await axios.get(
        `${BASE_API}/api/constancia-template/`,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const zip = new PizZip(templateResponse.data);
      const doc = new Docxtemplater(zip);
      const sexoAlumno = alumno?.sexo;
      const inscrito =
        sexoAlumno === "H" ? "inscrito" : sexoAlumno === "M" ? "inscrita" : "";
      const genero =
        sexoAlumno === "H" ? "alumno" : sexoAlumno === "M" ? "alumna" : "";
      const elLa = sexoAlumno === "H" ? "el" : sexoAlumno === "M" ? "la" : "";
      const interesadoa =
        sexoAlumno === "H"
          ? "del interesado"
          : sexoAlumno === "M"
          ? "de la interesada"
          : "";
      const elElla =
        sexoAlumno === "H" ? "el" : sexoAlumno === "M" ? "ella" : "";

      doc.setData({
        nombre: alumno.nombre.toUpperCase(),
        apellido_paterno: alumno.apellido_paterno.toUpperCase(),
        apellido_materno: alumno.apellido_materno.toUpperCase(),
        matricula: alumno.matricula,
        semestre: alumno.semestre,
        numero_grupo: grupo.numero_grupo,
        fecha_inicio: cicloEscolar.fecha_inicio,
        fecha_fin: cicloEscolar.fecha_fin,
        inicio: cicloAnio.anioInicio,
        fin: cicloAnio.anioFin,
        num_dia: fechaActual.diaNumero,
        mes: fechaActual.mes,
        anio: fechaActual.anioTexto,
        genero: inscrito,
        alum: genero,
        laEl: elLa,
        laDel: interesadoa,
        elElla: elElla,
        estado_alumno: estadoAlumno, // Estado del alumno
      });

      doc.render();

      const output = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      saveAs(output, `ConstanciaAlumno${alumno.matricula}.docx`);
    } catch (error) {
      console.error("Error generating document", error);
      setError("Error generating document");
    }
  };

  return (
    <div>
      <h1 className="tituloin">Constancias</h1>
      <h3>Buscar alumno</h3>
      <Form className="form-inline" onSubmit={handleSearchSubmit}>
        <Form.Group inline>
          <Form.Field>
            <Radio
              label="Matrícula"
              name="searchType"
              value="matricula"
              checked={searchType === "matricula"}
              onChange={() => setSearchType("matricula")}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="CURP"
              name="searchType"
              value="curp"
              checked={searchType === "curp"}
              onChange={() => setSearchType("curp")}
            />
          </Form.Field>
          <Form.Field>
            <Input
              placeholder={
                searchType === "matricula"
                  ? "Ingrese la matrícula"
                  : "Ingrese el CURP"
              }
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className="busper"
            />
          </Form.Field>
          <Button type="submit" className="botonEnviar">
            Buscar
          </Button>
        </Form.Group>
        {error && <Message negative>{error}</Message>}
      </Form>
      {alumno && grupo && cicloEscolar && (
        <div className="doc">
          <div className="cons">
            <p>ASUNTO: Constancia de Estudios. </p>
            <p>
              A QUIEN CORRESPONDA:<br></br>
              La que suscribe, Directora de la “Escuela Normal de Educación
              Preescolar”, <br></br>
            </p>
            <p>
              <strong>HACE CONSTAR</strong>
            </p>

            <p>
              {" "}
              Que {alumno.sexo === "M" ? "la" : "el"} C.{" "}
              <strong>
                {alumno.nombre.toUpperCase()}{" "}
                {alumno.apellido_paterno.toUpperCase()}{" "}
                {alumno.apellido_materno.toUpperCase()}
              </strong>
              , con número de matrícula <strong>{alumno.matricula}</strong>{" "}
              cursa la Licenciatura en Educación Preescolar, encontrándose
              inscrita en esta institución como{" "}
              {alumno.sexo === "M" ? "alumna" : "alumno"}{" "}
              <strong>{estadoAlumno}</strong> en el {alumno.semestre} Semestre
              del grupo {grupo.numero_grupo}, correspondiente al Ciclo Escolar{" "}
              {cicloAnio.anioInicio}-{cicloAnio.anioFin}, que comprende del{" "}
              {cicloEscolar.fecha_inicio} al {cicloEscolar.fecha_fin}.
            </p>
            <p>
              A petición{" "}
              {alumno.sexo === "M" ? "de la interesada" : "del interesado"} y
              para los usos legales que a {alumno.sexo === "M" ? "ella" : "el"}{" "}
              convengan, se extiende la presente en la ciudad de Oaxaca de
              Juárez, Oax., a los {fechaActual.diaNumero} días del mes de{" "}
              {fechaActual.mes} de {fechaActual.anioTexto}.
            </p>
          </div>
          <Button className="descarga" onClick={generateDocument}>
            Descargar documento
          </Button>
        </div>
      )}
    </div>
  );
}

export default ConstanciasAlumnos;
